<template>
  <ol class="mini-stations">
    <li
      v-for="(station, index) in stations"
      :key="index"
      class="station-wrapper"
    >
      <slot
        v-if="station !== null"
      >
        <div
          class="mini-stations__station g-btn g-btn--station"
          :title="station.description"
          :class="getStationClass(station)"
          @click.stop="stationClicked(station)"
        >
          <span class="g-btn--station__text">
            {{ station.name }}
          </span>
        </div>
        <!-- @TODO: Time below will need some work -->
        <div
          v-if="station.time"
          class="mini-stations__station__time"
        >
          {{ station.time ? station.time : '%' }}
        </div>
      </slot>
      <slot v-else>
        <div
          class="mini-stations__station g-btn g-btn--station g-btn--station--error"
        >
          <span class="g-btn--station__text">
            ERROR
          </span>
        </div>
      </slot>
    </li>
  </ol>
</template>

<script>

export default
{
  name: 'MiniStationsComponent',
  props: {
    stations: {
      type: Array,
      default() {
        return[]
      }
    },
    highlightedStations: {
      type: Array,
      default() {
        return[]
      }
    },
    selectedStationStId: {
      type: String,
      default() {
        return null
      }
    },
    showOnlyRunningStations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStations() {
      let stations = this.stations
      if(this.showOnlyRunningStations) {
        return stations.filter(station => station.isRunning)
      }

      return stations
    }
  },
  methods: {
    stationClicked(station) {
      this.$emit('stationClicked', station)
    },
    getStationClass(station) {
      let status = 'idle'

      if(station.isRunning) {
        status = 'active'
      }

      if(this.highlightedStations && this.highlightedStations.find(hStation => hStation === station.StId)) {
        status = 'ok'
      }

      if(this.selectedStationStId === station.StId) {
        status += ' g-btn--station--active-border'
      }

      if(station.status === '1') {
        status += ' g-btn--station--faulted'
      }

      return `g-btn--station--${status}`
    }
  }
}
</script>

<style lang="scss">
.mini-stations {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
  grid-gap: 10px;
  .station-wrapper {
    overflow: hidden;
    padding: 2px;
  }
  &__station {
    font-size: 11px;
    margin: 0 auto !important;
    &__time {
      padding: 5px;
      text-align: center;
      font-size: 11px;
    }
  }
}
</style>
